import { render, staticRenderFns } from "./CurrencyPriceOrTotal.vue?vue&type=template&id=626e7573&"
import script from "./CurrencyPriceOrTotal.vue?vue&type=script&lang=js&"
export * from "./CurrencyPriceOrTotal.vue?vue&type=script&lang=js&"
import style0 from "./CurrencyPriceOrTotal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VIcon})
